var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", {
      domProps: {
        innerHTML: _vm._s(
          _vm.$t("notification.settingUpdate", {
            user: _vm.$_.get(_vm.activity, "actorUser.name"),
          })
        ),
      },
    }),
    _vm._v(" "),
    _vm.$_.get(_vm.activity, "payload.updatedFields")
      ? _c("pre", { staticClass: "quote" }, [
          _vm._v(
            _vm._s(
              JSON.stringify(
                _vm.$_.get(_vm.activity, "payload.updatedFields"),
                null,
                2
              )
            )
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }